<div
  class="[ absolute top-none bottom-none ] [ icon-size-2xs ] [ corner-full ]"
  [ngClass]="progress < 100 ? color : ['surface', 'clip-check']"
  [style.clipPath]="progress < 100 ? 'inset(calc((100 - var(--progress, 0)) * 1%) 0 0 0)' : ''"
></div>
<div
  class="[ absolute top-none bottom-none ] [ surface icon-size-2xs ] [ border corner-full ] [ index-pullback ]"
  [ngClass]="progress === 100 ? [color, 'border-' + color] : ['border-' + color]"
></div>
